import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=62b7313e&scoped=true&"
import script from "./appoint.vue?vue&type=script&lang=js&"
export * from "./appoint.vue?vue&type=script&lang=js&"
import style0 from "./appoint.vue?vue&type=style&index=0&id=62b7313e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7313e",
  null
  
)

export default component.exports